export const FacebookProvider = 'Facebook';
export const InstagramProvider = 'Instagram';
export const TwitterProvider = 'Twitter';
export const YoutubeProvider = 'Youtube';
export const AllProvider = 'All';
export const FFR_FACEBOOK = 'https://www.facebook.com/FFRugby/';
export const FFR_INSTAGRAM = 'https://www.instagram.com/ffrugby/';
export const FFR_TWITTER = 'https://twitter.com/ffrugby';
export const FFR_YOUTUBE = 'https://www.youtube.com/channel/UCnH0bSmQqDBfNj9kZzCaINw';
